import React, { Component } from "react";
import { Table, Button, Modal, Col, Row, message, Tooltip, Select, Input, Menu, Dropdown, Icon } from "antd";
import axios from "axios";
import "./Pages.css";
import PedidoFiltroForm from '../components/PedidoFiltroForm';
import OrçamentosPrintModal from "../relatorios/OrçamentosPrintModal";
import OrcamentoPrintModal from "../relatorios/OrcamentoPrintModal";
import OrcamentoReduzidaPrintModal from "../relatorios/OrcamentoReduzidaPrintModal";
import OrcamentoPrintCupomModal from "../relatorios/OrcamentoPrintCupomModal";
import OrcamentoForm from '../components/OrcamentoForm';
import moment from "moment-timezone";
import numeral from "numeral";
import { getUsuario, getTemPermissao } from "../utils/LoginManager";
import Colors from '../utils/Colors';
import LancOrcamentos from '../tutoriais/LancOrcamentos';

const { Column } = Table;
const ButtonGroup = Button.Group;
const { Option } = Select;
const { Search } = Input;


export default class extends Component {
  state = {
    listaRegistros: [],
    carregando: false,
    pagina: 1,
    limite: 10,
    total: 0,
    totalOS: 0,
    qtdeOS: 0,
    formFiltroVisivel: false,
    formPrintOSVisivel: false,
    formPrintCupomVisivel: false,
    formPrint2ViasVisivel: false,
    idfOS: 0,

    filtros: {
      tipoTela: 'ORC',
      buscaOrdem: { campo: 'orc_data_emissao', ordem: 'DESC' },
      buscaDataIni: moment(new Date(new Date().getFullYear(), new Date().getMonth() - 6, 1)).format('DD/MM/YYYY'),
      buscaDataFim: moment(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).format('DD/MM/YYYY'),
      buscaControle: '',
      buscaPessoa: { key: '0', },
      buscaProduto: { key: '0', },
      buscaGrupoProduto: { key: '0', },
      buscaMarcaProduto: { key: '0', },
      buscaServico: { key: '0', },
      buscaUsuario: { key: '0', },
      buscaSitFin: { key: 'X', },
      buscaVeiculo: '',
    }


  };


  componentDidMount() {
    const usuario = getUsuario();
    this.setState({ usuario }, this.getListaRegistros);
  }

  componentDidUpdate(antProps, antState) {
    const { total, pagina, limite } = this.state;
    const ultimaPagina = Math.ceil(total / limite);
    if (pagina > 1 && pagina > ultimaPagina) {
      this.setState({
        pagina: ultimaPagina
      }, this.getListaRegistros)
    }
  }



  getListaRegistros = () => {
    this.setState({ listaRegistros: [], carregando: true, totalOS: 0, qtdeOS: 0 });
    const { pagina, limite } = this.state;
    const { buscaDataIni, buscaDataFim, buscaControle, buscaPessoa, buscaUsuario, buscaOrdem, buscaVeiculo } = this.state.filtros;

    let dataIni = '';
    if ((buscaDataIni) && (buscaDataIni !== undefined)) {
      dataIni = moment(buscaDataIni, 'DD/MM/YYYY').format('YYYY-MM-DD');
    }
    let dataFim = '';
    if ((buscaDataFim) && (buscaDataFim !== undefined)) {
      dataFim = moment(buscaDataFim, 'DD/MM/YYYY').format('YYYY-MM-DD');
    }

    axios
      .get('/orcamentos', {
        params: {
          page: pagina,
          limite: limite,
          campoOrdem: buscaOrdem.campo,
          tipoOrdem: buscaOrdem.ordem,
          numero: buscaControle,
          veiculo: buscaVeiculo,
          pessoa: buscaPessoa.key,
          usuario: buscaUsuario.key,
          dataIni,
          dataFim,
        }
      })
      .then(response => {
        const { data, total, current_page, per_page } = response.data.dados;
        this.setState({
          listaRegistros: data,
          carregando: false,
          total: total,
          pagina: current_page,
          limite: Number(per_page),

          totalOS: response.data.totalOS,
          qtdeOS: response.data.qtdeOS,
        });
      })
      .catch(erro => {
        console.warn(erro);
        this.setState({
          carregando: false,
        });
      });
  };



  onSalvarClick = (registro) => {
    this.setState({
      salvando: true
    })

    // console.log('Registro gravar: ', registro);
    let request;
    if (registro.orc_idf) {
      request = axios.put(`/orcamentos/update/${registro.orc_idf}`, registro);
    } else {
      request = axios.post(`/orcamentos/store`, registro)
    }

    request
      .then(response => {
        this.getListaRegistros();
        this.setState({
          formVisivel: false,
          salvando: false,
        })
        // console.log('onSalvarClick: ', response.data)
        if (!registro.orc_idf) {
          if (this.state.usuario.par_impr_os === 'COM') {
            this.onImprimirOSClick(response);
          } else if (this.state.usuario.par_impr_os === 'CUP') {
            this.onImprimirCupomClick(response.data.idf);
          } else if (this.state.usuario.par_impr_os === 'RED') {
            this.onImprimir2ViasClick(response.data.idf);
          }
        }
        message.success('Orçamento gravado com sucesso.');
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          salvando: false
        })
        if (error.response.status === 412) {
          Modal.error({ title: 'Atenção', content: error.response.data, okText: 'OK', })
        } else {
          Modal.error({ title: 'Falha - Atenção!', content: 'Não foi possível salvar. ' + error.response.data, okText: 'OK', })
        }
      })
  }

  onAdicionarClick = () => {
    this.setState({
      formVisivel: true,
      visualizar: false,
      registroSelecionado: {
        dados: {
          orc_idf: 0,
          orc_numero: '',
          orc_situacao: { key: 'ABE' },
          orc_vlr_itens: 0,
          orc_desc_itens: 0,
          orc_acres_itens: 0,
          orc_desc_orc: 0,
          orc_acresc_orc: 0,
          orc_vlr_total: 0,
          orc_cliente: {
            key: String(this.state.usuario.par_cliente),
            label: this.state.usuario.pes_nome_cli,
          },
          orc_data_emissao: moment().format('DD/MM/YYYY'),
          orc_usuario: {
            key: this.state.usuario.par_vendedor ? String(this.state.usuario.par_vendedor) : '0',
            label: this.state.usuario.par_vendedor ? this.state.usuario.usu_nome : '',
          },
          orc_cond_pagto: {
            key: String(this.state.usuario.par_cond_pagto_padrao),
            label: this.state.usuario.td_descricao,
            qtdeParc: this.state.usuario.cp_qtde_parc,
            parcAVista: this.state.usuario.cp_parc_avista,
          },
          orc_descricao: '',
          orc_nome_cliente: '',
          orc_fone: '',
          orc_endereco: '',
          orc_atividade: '',
          orc_obs: '',
          orc_veiculo: 0,
          veic_descricao: '',

          listaProdutos: [],
          listaCheckList: [],
          visualizando: false,
        }
      },

    })
  };

  onCancelarClick = () => {
    this.setState({
      formVisivel: false
    })
  }

  onEditarClick = (registro, visualizar) => {
    this.setState({ carregando: true });
    axios.get(`/orcamentos/show/${registro.orc_idf}`)
      .then(response => {
        const { data } = response;

        data.dados.orc_situacao = {
          key: String(data.dados.orc_situacao),
          label: '',
        }
        data.dados.orc_cliente = {
          key: String(data.dados.orc_cliente),
          label: data.dados.pes_nome,
        }
        data.dados.orc_usuario = {
          key: String(data.dados.orc_usuario),
          label: data.dados.usu_nome,
        }
        data.dados.orc_cond_pagto = {
          key: data.dados.orc_cond_pagto ? String(data.dados.orc_cond_pagto) : 0,
          label: data.dados.cp_descricao ? data.dados.cp_descricao : '',
        }

        data.dados.orc_data_emissao = moment(data.dados.orc_data_emissao, 'YYYY-MM-DD').format('DD/MM/YYYY');
        data.dados.visualizando = false;

        let listaProdutos = [];
        for (var x in data.listaProdutos) {

          if (data.listaProdutos[x].oi_item) {

            listaProdutos.push({
              ven_idf: 0,
              venc_idf: 0,
              mi_idf_condicional: 0,
              mi_item: data.listaProdutos[x].oi_item,
              mi_servico: { key: '0' },
              mi_item_Avulso: '',
              mi_seq: listaProdutos.length + 1,
              prod_idf: data.listaProdutos[x].prod_idf,
              pest_qtde: data.listaProdutos[x].oi_qtde,
              prod_grade: 0,
              mi_item_tamanho: 0,
              mi_item_cor: 0,
              ptam_descricao: '',
              pcor_descricao: '',
              prod_codigo: data.listaProdutos[x].prod_codigo,
              prod_descricao: data.listaProdutos[x].prod_descricao,
              prod_cod_barras: data.listaProdutos[x].prod_cod_barras,
              mi_qtde: parseFloat(data.listaProdutos[x].oi_qtde),
              osia_custo_unit: 0,
              mi_vlr_unit: parseFloat(data.listaProdutos[x].oi_vlr_unit),
              mi_vlr_venda: parseFloat(data.listaProdutos[x].oi_vlr_unit),
              mi_vlr_venda_min: parseFloat(data.listaProdutos[x].oi_vlr_unit),
              mi_perc_desc: 0,
              mi_vlr_desc: parseFloat(data.listaProdutos[x].oi_vlr_desc),
              mi_vlr_acres: parseFloat(data.listaProdutos[x].oi_vlr_acresc),
              mi_vlr_total: parseFloat(data.listaProdutos[x].oi_vlr_total),
              mi_calc_estoque: parseFloat(data.listaProdutos[x].prod_controla_estoque),
              tipoItem: 'P',
            });

          } else if (data.listaProdutos[x].oi_servico) {

            listaProdutos.push({
              ven_idf: 0,
              venc_idf: 0,
              mi_idf_condicional: 0,
              mi_item: { key: '0' },
              mi_servico: data.listaProdutos[x].oi_servico,
              mi_item_Avulso: '',
              mi_seq: listaProdutos.length + 1,
              prod_idf: '',
              pest_qtde: 0,
              prod_grade: '',
              mi_item_tamanho: '',
              mi_item_cor: '',
              ptam_descricao: '',
              pcor_descricao: '',
              prod_codigo: '',
              prod_descricao: data.listaProdutos[x].serv_descricao,
              prod_cod_barras: '',
              mi_qtde: parseFloat(data.listaProdutos[x].oi_qtde),
              osia_custo_unit: 0,
              mi_vlr_unit: parseFloat(data.listaProdutos[x].oi_vlr_unit),
              mi_vlr_venda: parseFloat(data.listaProdutos[x].oi_vlr_unit),
              mi_vlr_venda_min: parseFloat(data.listaProdutos[x].oi_vlr_unit),
              mi_perc_desc: 0,
              mi_vlr_desc: 0,
              mi_vlr_acres: 0,
              mi_vlr_total: parseFloat(data.listaProdutos[x].oi_vlr_total),
              mi_calc_estoque: 0,
              tipoItem: 'S',
            });

          } else {

            listaProdutos.push({
              ven_idf: 0,
              venc_idf: 0,
              mi_idf_condicional: 0,
              mi_item: { key: '0' },
              mi_servico: 0,
              mi_item_Avulso: data.listaProdutos[x].oi_item_avulo,
              mi_seq: listaProdutos.length + 1,
              prod_idf: '',
              pest_qtde: 0,
              prod_grade: '',
              mi_item_tamanho: '',
              mi_item_cor: '',
              ptam_descricao: '',
              pcor_descricao: '',
              prod_codigo: '',
              prod_descricao: data.listaProdutos[x].oi_item_avulo,
              prod_cod_barras: '',
              mi_qtde: parseFloat(data.listaProdutos[x].oi_qtde),
              osia_custo_unit: parseFloat(data.listaProdutos[x].oi_vlr_unit),
              mi_vlr_unit: parseFloat(data.listaProdutos[x].oi_vlr_unit),
              mi_vlr_venda: parseFloat(data.listaProdutos[x].oi_vlr_unit),
              mi_vlr_venda_min: parseFloat(data.listaProdutos[x].oi_vlr_unit),
              mi_perc_desc: 0,
              mi_vlr_desc: 0,
              mi_vlr_acres: 0,
              mi_vlr_total: parseFloat(data.listaProdutos[x].oi_vlr_total),
              mi_calc_estoque: 0,
              tipoItem: 'A',
            });

          }

        };
        data.listaProdutos = listaProdutos;


        let listaCheckList = [];
        for (var x in data.listaCheckList) {
          listaCheckList.push({
            clos_idf: data.listaCheckList[x].clos_idf,
            clos_descricao: data.listaCheckList[x].clos_descricao,
            check: data.listaCheckList[x].orccl_check,
            obs: data.listaCheckList[x].orccl_obs,
          });
        };
        data.listaCheckList = listaCheckList;


        this.setState({
          formVisivel: true,
          registroSelecionado: {
            ...data,
            visualizar,
          },
          carregando: false,
        })
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          carregando: false,
        })
      })
  };

  onExcluirClick = registro => {
    Modal.confirm({
      title: 'Confirmação de Exclusão',
      content: `Deseja excluir este registro?`,
      okText: 'Sim',
      cancelText: 'Não',
      onOk: () => {
        this.setState({ carregando: true });
        axios.delete(`/orcamentos/delete/${registro.orc_idf}`)
          .then(response => {
            const { listaRegistros, total } = this.state;
            const registroIndex = listaRegistros.findIndex(tar => tar.orc_idf === registro.orc_idf)
            listaRegistros.splice(registroIndex, 1);
            this.setState({
              listaRegistros: listaRegistros.concat([]),
              total: total - 1,
              carregando: false,
            })

          }).catch(error => {
            console.error(error.response);
            this.setState({
              carregando: false,
            })
            if (error.response.status === 412) {
              Modal.error({ title: 'Atenção', content: error.response.data, okText: 'OK', })
            } else {
              Modal.error({ title: 'Falha - Atenção!', content: 'Não foi possível excluir. ' + error.response.data, okText: 'OK', })
            }
          })
      }
    })
  };

  onGerarOSClick = registro => {
    Modal.confirm({
      title: 'Confirmação de O.S',
      content: `Deseja gerar Ordem de Serviço deste Orçamento?`,
      okText: 'Sim',
      cancelText: 'Não',
      onOk: () => {
        this.setState({ carregando: true });

        axios.put(`/orcamentos/gerarOS/${registro.orc_idf}`)
          .then(response => {
            // console.log('onGerarOSClick: ', response.data)

            this.setState({
              carregando: false,
            })
            message.success('Ordem de serviço N° ' + registro.data + ' criada com sucesso.');
            this.getListaRegistros();

          })
          .catch(error => {
            console.error(error.response);
            this.setState({
              carregando: false
            })
            if (error.response.status === 412) {
              Modal.error({ title: 'Atenção', content: error.response.data, okText: 'OK', })
            } else {
              Modal.error({ title: 'Falha - Atenção!', content: 'Não foi possível salvar. ' + error.response.data, okText: 'OK', })
            }
          })
      }
    })
  };

  onImprimirOSClick = (registro) => {
    // this.setState({
    //   idfOS: orc_idf,
    //   formPrintOSVisivel: true,
    // });

    this.setState({ carregando: true });
    const reg = {
      orc_idf: String(registro.orc_idf),
    };
    axios.post('/orcamentos/montaPDF', reg)
      .then(response => {
        const { data } = response;
        const file_url = 'https://api.fastgestor.plenasistemas.inf.br/image/emp' + registro.orc_empresa + '/pdf/' + data.nomeArq;
        window.open(file_url, '_blank')
      }).catch(ex => {
        Modal.warning({ title: 'Aviso!', content: 'Não foi possível localizar o Orçamento', });
        this.setState({ carregando: false });
        console.warn(ex);
      });
    this.setState({
      carregando: false,
    })
  };

  onImprimirCupomClick = (orc_idf) => {
    this.setState({
      idfOS: orc_idf,
      formPrintCupomVisivel: true,
    });
  };

  onImprimir2ViasClick = (orc_idf) => {
    this.setState({
      idfOS: orc_idf,
      formPrint2ViasVisivel: true,
    });
  };

  onCancelarPrintClick = () => {
    this.setState({
      idfOS: 0,
      formPrintOSVisivel: false,
      formPrintCupomVisivel: false,
      formPrint2ViasVisivel: false,
    })
  }




  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    this.setState({ [id]: value });
  };


  onAbrirFiltroClick = () => {
    this.setState({
      formFiltroVisivel: true,
      filtros: {
        tipoTela: this.state.filtros.tipoTela,
        buscaOrdem: this.state.filtros.buscaOrdem,
        buscaDataIni: this.state.filtros.buscaDataIni,
        buscaDataFim: this.state.filtros.buscaDataFim,
        buscaControle: String(this.state.filtros.buscaControle),
        buscaUsuario: this.state.filtros.buscaUsuario,
        buscaPessoa: this.state.filtros.buscaPessoa,
        buscaProduto: this.state.filtros.buscaProduto,
        buscaGrupoProduto: this.state.filtros.buscaGrupoProduto,
        buscaMarcaProduto: this.state.filtros.buscaMarcaProduto,
        buscaServico: this.state.filtros.buscaServico,
        buscaSitFin: this.state.filtros.buscaSitFin,
        buscaVeiculo: this.state.filtros.buscaVeiculo,
      }
    })
  };

  onFiltrarClick = (filtros) => {
    this.setState({
      formFiltroVisivel: false,
      filtros,
    },
      this.getListaRegistros(filtros)
    )
  };

  onCancelarFiltroClick = () => {
    this.setState({
      formFiltroVisivel: false,
    })
  };


  onOrdenarListaClick = (column) => {
    const { filtros } = this.state;
    const ordem = filtros.buscaOrdem.campo && filtros.buscaOrdem.campo === column.dataIndex ? (filtros.buscaOrdem.ordem && filtros.buscaOrdem.ordem === 'ASC' ? 'DESC' : 'ASC') : 'ASC';
    filtros['buscaOrdem'] = { campo: column.dataIndex, ordem };
    this.setState({
      filtros,
      pagina: 1,
    }, this.getListaRegistros)
  };

  renderTitulo = (col) => {
    return (
      <Tooltip title="Clique para Ordenar"><div style={{ background: "#ececec", cursor: 'pointer', padding: 2, marginLeft: -5, marginRight: -5 }}>{col}</div></Tooltip>
    );
  };




  renderData = (data) => {
    if (data) {
      const dataMoment = moment(data);
      return (
        <span>
          {dataMoment.format('DD/MM/YYYY HH:mm')}
        </span>
      )
    } else {
      return (
        <span></span>
      )
    }
  }


  renderAcoes = (text, registro) => {
    return (
      <ButtonGroup size="small">
        {getTemPermissao('OrcamentosPage', 'editar') ? (
          <span>
            <Tooltip title="Editar">
              <Button type="primary" size="small" onClick={() => this.onEditarClick(registro, false)} icon="edit" />
            </Tooltip>
          </span>
        ) : (
          <span>
            <Tooltip title="Visualizar">
              <Button type="ghost" size="small" onClick={() => this.onEditarClick(registro, true)} icon="eye" />
            </Tooltip>
          </span>
        )}
        {getTemPermissao('OrcamentosPage', 'excluir') ? (
          <span>
            <Tooltip title="Excluir">
              <Button type="danger" size="small" onClick={() => this.onExcluirClick(registro)} icon="delete" />
            </Tooltip>
          </span>
        ) : null}

        <span>
          <Tooltip title="Impressão">
            <Dropdown overlay={
              <Menu >
                <Menu.Item key="1" onClick={() => this.onImprimirOSClick(registro)}>Completa</Menu.Item>
                <Menu.Item key="2" onClick={() => this.onImprimir2ViasClick(registro.orc_idf)}>2 Vias</Menu.Item>
                <Menu.Item key="3" onClick={() => this.onImprimirCupomClick(registro.orc_idf)}>Cupom</Menu.Item>
              </Menu>
            } placement="bottomRight">
              <Button type="ghost"><Icon type="printer" /></Button>
            </Dropdown>
          </Tooltip>
        </span>
        <span>
          <Tooltip title="Gerar O.S.">
            <Button type="ghost" size="small" onClick={() => this.onGerarOSClick(registro, false)} icon="folder-add" />
          </Tooltip>
        </span>
      </ButtonGroup>
    );
  };


  onChangeSituacao = (registro, event) => {
    this.setState({ carregando: true })
    axios.
      put(`/orcamentos/mudaSituacao/${registro.orc_idf}/${event}`)
      .then(response => {
        registro.orc_situacao = event;
        this.setState({
          listaRegistros: this.state.listaRegistros.concat([]),
          carregando: false
        })
      }).catch(error => {
        console.error(error.response);
        this.setState({ carregando: false })
      })
  };

  renderSitOS = (sit, registro) => {
    const orc_situacao = { key: sit }
    return (
      <Select
        style={{ width: 150 }}
        onChange={situcao => this.onChangeSituacao(registro, situcao)}
        defaultValue={sit}
      >
        <Option value="ABE">ABERTO</Option>
        <Option value="ESP">ESPERA</Option>
        <Option value="APR">APROVADO</Option>
        <Option value="FEC">FECHADO</Option>
      </Select>

    );
  };

  renderValor = (vlr, registro) => {
    return (
      <span> {numeral(parseFloat(vlr)).format('0,000.00')} </span>
    );
  };

  renderNome = (nome, registro) => {
    return (
      <span> {registro.orc_nome_cliente ? registro.orc_nome_cliente : registro.pes_nome} </span>
    );
  };



  onTabelaChange = (pagination => {
    this.setState({
      pagina: pagination.current,
      limite: pagination.pageSize,
    },
      this.getListaRegistros)
  })

  renderVendedor = (usu_nome) => {
    return (
      <span>{usu_nome.substring(0, 10)}</span>
    );
  };


  onBuscar = (texto) => {
    this.setState({
      filtros: {
        tipoTela: this.state.filtros.tipoTela,
        buscaOrdem: this.state.filtros.buscaOrdem,
        buscaDataIni: this.state.filtros.buscaDataIni,
        buscaDataFim: this.state.filtros.buscaDataFim,
        buscaControle: String(texto),
        buscaUsuario: this.state.filtros.buscaUsuario,
        buscaPessoa: this.state.filtros.buscaPessoa,
        buscaProduto: this.state.filtros.buscaProduto,
        buscaGrupoProduto: this.state.filtros.buscaGrupoProduto,
        buscaMarcaProduto: this.state.filtros.buscaMarcaProduto,
        buscaServico: this.state.filtros.buscaServico,
        buscaSitFin: this.state.filtros.buscaSitFin,
        buscaVeiculo: this.state.filtros.buscaVeiculo,
      }
    },
      this.getListaRegistros);
  };



  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------


  render() {
    const { listaRegistros, carregando, formVisivel, salvando, registroSelecionado,
      filtros, formFiltroVisivel, formPrintOSVisivel, formPrintCupomVisivel, formPrint2ViasVisivel,
      total, pagina, limite } = this.state;
    const { buscaControle } = this.state.filtros;

    // console.log('OrcamentosPage.this.state: ', this.state);

    return (
      <div className="contentRoutesContainer">
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <span className="tituloPage">Orçamentos</span>
          <Tooltip title="Ajuda">
            <Button
              type="primary"
              onClick={() => this.setState({ modalOpen: true })}
              icon="question"
              style={{ fontSize: 20, marginTop: 8, backgroundColor: Colors.primaryLight, borderColor: Colors.primaryLight }}
            ></Button>
          </Tooltip>
        </div>
        <div className="divider-page1" />

        <div className="pageFiltro" style={{ height: 50 }}>
          <Col xs={24} >
            <Col xs={12}>
              {getTemPermissao('OrcamentosPage', 'novo') ? (
                <Col xs={2} style={{ width: 110 }}>
                  <Button
                    type="primary"
                    onClick={this.onAdicionarClick}
                    className="botao-primary"
                  >
                    Adicionar
                  </Button>
                </Col>
              ) : null}

              <Col xs={2} style={{ width: 110 }}>
                <Button
                  type="primary"
                  onClick={this.onAbrirFiltroClick}
                  className="botao-primary"
                  style={{ marginRight: 15 }}
                >
                  Filtrar
                </Button>
              </Col>

              <Col xs={2} style={{ width: 110 }}>
                <OrçamentosPrintModal
                  filtros={filtros}
                  totalOS={this.state.totalOS}
                  qtdeOS={this.state.qtdeOS}
                />
              </Col>

              <Col xs={6}>
                <Search
                  placeholder="Nº Orçamento"
                  onSearch={this.onBuscar}
                  enterButton
                  className="pageFiltro-busca"
                />
              </Col>

              <PedidoFiltroForm
                visivel={formFiltroVisivel}
                onFiltrarClick={this.onFiltrarClick}
                onCancelarFiltroClick={this.onCancelarFiltroClick}
                filtros={filtros}
              />

              <OrcamentoForm
                isOpen={this.state.modalOpen}
                onClose={() => this.setState({ modalOpen: false })}
              />
            </Col>

            <Col xs={24} md={8} style={{ height: 65, padding: 5, marginTop: -25 }}>
              <Col xs={24} md={12} style={{ height: 65, padding: 5 }}>
                <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: "white" }}>
                  <Row style={{ textAlign: "center", marginTop: 0, marginBottom: 5 }}>
                    <span style={{ fontSize: 17, fontWeight: "bold", color: Colors.primary }}>
                      Qtde
                    </span>
                  </Row>
                  <Row style={{ textAlign: "center" }}>
                    <Row style={{ marginTop: -5 }}>
                      <span style={{ fontSize: 14, fontWeight: "bold", color: "rgba(0, 0, 0, 0.45)" }}>{this.state.qtdeOS}</span>
                    </Row>
                  </Row>
                </div>
              </Col>
              <Col xs={24} md={12} style={{ height: 65, padding: 5 }}>
                <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: "white" }}>
                  <Row style={{ textAlign: "center", marginTop: 0, marginBottom: 5 }}>
                    <span style={{ fontSize: 17, fontWeight: "bold", color: Colors.primary }}>
                      Valor Total
                    </span>
                  </Row>
                  <Row style={{ textAlign: "center" }}>
                    <Row style={{ marginTop: -5 }}>
                      <span style={{ fontSize: 14, fontWeight: "bold", color: "rgba(0, 0, 0, 0.45)" }}>{this.renderValor(this.state.totalOS)}</span>
                    </Row>
                  </Row>
                </div>
              </Col>
            </Col>
          </Col>

          <OrcamentoForm
            visivel={formVisivel}
            onSalvarClick={this.onSalvarClick}
            onCancelarClick={this.onCancelarClick}
            carregando={salvando}
            registroSelecionado={registroSelecionado}
          />

          <OrcamentoPrintModal
            visivel={formPrintOSVisivel}
            orc_idf={this.state.idfOS}
            tipoVenda="ORC"
            onCancelarPrintClick={this.onCancelarPrintClick}
          />

          <OrcamentoPrintCupomModal
            visivel={formPrintCupomVisivel}
            orc_idf={this.state.idfOS}
            tipoVenda="ORC"
            onCancelarPrintClick={this.onCancelarPrintClick}
          />

          <OrcamentoReduzidaPrintModal
            visivel={formPrint2ViasVisivel}
            orc_idf={this.state.idfOS}
            tipoVenda="ORC"
            onCancelarPrintClick={this.onCancelarPrintClick}
          />

        </div>



        <div style={{ paddingTop: 0 }}>
          <Table
            pagination={{
              total: total,
              pageSize: limite,
              current: pagina,
              pageSizeOptions: ['10', '20', '30', '40'],
              showSizeChanger: true,
            }}
            onChange={this.onTabelaChange}
            loading={{
              spinning: carregando,
              tip: 'Carregando. Aguarde...',
              size: "large"
            }}
            dataSource={listaRegistros}
            rowKey={(registro => registro.orc_idf)}
          >
            <Column
              key="orc_numero"
              dataIndex="orc_numero"
              title={this.renderTitulo("Número")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              width={80}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="orc_data_emissao"
              dataIndex="orc_data_emissao"
              title={this.renderTitulo("Emissão")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderData}
              width={140}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="pes_nome"
              dataIndex="pes_nome"
              title={this.renderTitulo("Cliente")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderNome}
              width={120}
              align="left"
              className="listaCadastro"
            />
            <Column
              key="orc_descricao"
              dataIndex="orc_descricao"
              title={this.renderTitulo("Descrição")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              width={150}
              align="left"
              className="listaCadastro"
            />
            <Column
              key="usu_nome"
              dataIndex="usu_nome"
              title={this.renderTitulo("Vendedor")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderVendedor}
              width={80}
              align="left"
              className="listaCadastro"
            />
            <Column
              key="orc_vlr_total"
              dataIndex="orc_vlr_total"
              title={this.renderTitulo("Valor Total")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderValor}
              width={90}
              align="right"
              className="listaCadastro"
            />
            <Column
              key="orc_situacao"
              dataIndex="orc_situacao"
              title={this.renderTitulo("Situação")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderSitOS}
              width={100}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="acoes"
              title={<div style={{ background: "#ececec", padding: 2, marginLeft: -5, marginRight: -5 }}>.</div>}
              render={this.renderAcoes}
              width={140}
              align="center"
              className="listaCadastro"
            />
          </Table>
        </div>
      </div >
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/OrcamentosPage.js